import React from 'react';
import Edit_Employee from './Edit_Employee';
import '../../../CommonCSS/SocietyCSS.css'


const EditEmployeeApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> Edit Employe </h5>
          </div>
        </div>
        <Edit_Employee/>
      </div>
    </div >
  );
};

export default EditEmployeeApp;
